import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouter = ({ token }) => {
  // prefer prop but fall back to latest value from localStorage
  const authToken = token || localStorage.getItem("GSTB_token");

  if (!authToken) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRouter;
